/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TeachingFormatEnum {
    Frecventa = 'Frecventa',
    FrecventaRedusa = 'FrecventaRedusa',
    Distanta = 'Distanta'
}

export function TeachingFormatEnumFromJSON(json: any): TeachingFormatEnum {
    return TeachingFormatEnumFromJSONTyped(json, false);
}

export function TeachingFormatEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeachingFormatEnum {
    return json as TeachingFormatEnum;
}

export function TeachingFormatEnumToJSON(value?: TeachingFormatEnum | null): any {
    return value as any;
}

